//
// ResultDefinition.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataDefinition";
import "./MaxRowsLookup";
import "./MaxRowsBehavior";
import "./ResultDefinitionFormat";

var ResultDefinition = createModule("BIRD::ResultDefinition", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::DataDefinition"], EventDispatcher, [
    ,
    {
        maxRows: 4,
        maxRowsBehavior: 4,
        purpose: 7,
        format: 4,
        maxRowsLookup: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResultDefinition;
